module.exports = __webpack_public_path__ + "img/d.c38b264c.jpg";